import { createAction, props } from '@ngrx/store';
import { AppConfig } from '@shared/interfaces';

export const load = createAction(
    '[Config] Load config'
);

export const loginSuccess = createAction(
    '[Config] Load config success',
    props<{config: AppConfig}>()
);

export const loginFailure = createAction(
    '[Config] Load config failure',
    props<{error: any}>()
);
